import request from "@/utils/request";

// 协会简介 or 协会章程
export function getItem(data) {
  return request({
    url: "/api/overview/get",
    method: "post",
    data,
  });
}
// 组织机构
export function getDepartment(params) {
  return request({
    url: "api/department/get",
    method: "get",
    params,
  });
}
// 列表
export function getCouncil(data) {
  return request({
    url: "/api/council/get",
    method: "post",
    data,
  });
}
